import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";

const steps = [
  {
    n: "01",
    title: "Scan and pick a vehicle",
    body: "Open the app, find an electric scooter parked nearby, and scan its QR code. Quick and convenient.",
  },
  {
    n: "02",
    title: "Quick App Verification",
    body: "Complete a simple 1-minute identity check directly inside the app to unlock your ride instantly.",
  },
  {
    n: "03",
    title: "Ride, park, and end the trip",
    body: "Ride wherever you need to go, park it in any marked zone, and tap 'End ride' to close out your fare automatically.",
  },
];

export default function HowItWorks() {
  return (
    <Box id="how-it-works" component="section" sx={{ py: { xs: 8, md: 12 }, bgcolor: "background.paper" }}>
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 4, md: 6 }} alignItems="flex-start">
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                display: "inline-block",
                px: 2,
                py: 0.6,
                borderRadius: "20px",
                bgcolor: "rgba(27, 78, 216, 0.08)",
                color: "primary.main",
                fontSize: 12.5,
                fontWeight: 700,
                letterSpacing: "0.06em",
                textTransform: "uppercase",
                mb: 2,
              }}
            >
              HOW IT WORKS
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontFamily: "'Space Grotesk', sans-serif",
                fontSize: { xs: 30, md: 38 },
                fontWeight: 700,
                color: "text.primary",
                mb: 2,
                letterSpacing: "-0.02em",
              }}
            >
              Three steps.{" "}
              <Box component="span" sx={{ color: "primary.main" }}>
                Ride in minutes.
              </Box>
            </Typography>
            <Typography sx={{ color: "text.secondary", fontSize: 16, lineHeight: 1.7 }}>
              Every step is designed for fast, seamless access so you can unlock a scooter and start riding in under 2 minutes.
            </Typography>
          </Grid>

          <Grid item xs={12} md={8}>
            <Grid container spacing={3}>
              {steps.map((step) => (
                <Grid item xs={12} sm={4} key={step.n}>
                  <Box
                    sx={{
                      bgcolor: "background.default",
                      borderRadius: "16px",
                      p: { xs: 3, md: 3.5 },
                      height: "100%",
                      border: "1px solid",
                      borderColor: "divider",
                      position: "relative",
                      overflow: "hidden",
                      transition: "transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease",
                      "&:hover": {
                        transform: "translateY(-4px)",
                        borderColor: "secondary.main",
                        boxShadow: "0 14px 30px -12px rgba(114, 191, 32, 0.25)",
                      },
                    }}
                  >
                    {/* Top Accent Line */}
                    <Box sx={{ position: "absolute", top: 0, left: 0, right: 0, height: 3, bgcolor: "secondary.main" }} />

                    <Typography
                      sx={{
                        fontFamily: "'Space Grotesk', sans-serif",
                        fontSize: 32,
                        color: "secondary.main",
                        fontWeight: 700,
                        lineHeight: 1,
                        mb: 2,
                      }}
                    >
                      {step.n}
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{
                        fontFamily: "'Space Grotesk', sans-serif",
                        fontSize: 17,
                        fontWeight: 700,
                        color: "text.primary",
                        mb: 1.25,
                      }}
                    >
                      {step.title}
                    </Typography>
                    <Typography sx={{ fontSize: 13.5, color: "text.secondary", lineHeight: 1.65 }}>
                      {step.body}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
